module.exports = __webpack_public_path__ + "img/HC1003-162.8c73f3ed.jpg";